import styled from 'styled-components'

const StyledUnidadeArredondamento = styled.div`
  height: calc(100vh - 310px);
  position: relative;
  background-color: white;

.unidade-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 100px;
  align-items: center;
  background-color: var(--color-neutral-background);
}

.footer-dialog-buttons{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: right;
  padding-top: 30px;
}

.label-input {
  text-transform: uppercase;
  color: red;
}

.button{
  margin: 2px;
  width: 170px;
  background-color: red !important;
}
`
export default StyledUnidadeArredondamento